const typography = {
  _fontFaces: {
    sansSerifFontFamilyLight: 'var(--font-inter)',
    sansSerifFontFamilyRegular: 'var(--font-inter)',
    sansSerifFontFamilySemiBold: 'var(--font-inter)',
    sansSerifFontFamilyBold: 'var(--font-inter)',

    serifFontFamilyLight: 'var(--font-lexend)',
    serifFontFamilyRegular: 'var(--font-lexend)',
    serifFontFamilyBold: 'var(--font-lexend)'
  },
  sansSerifHighlight3: {
    fontFamily: 'var(--font-inter)',
    fontSize: '56px',
    lineHeight: '1.14285714em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  sansSerifHighlight2: {
    fontFamily: 'var(--font-inter)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  sansSerifHighlight2Light: {
    fontFamily: 'var(--font-inter)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  sansSerifHighlight2Bold: {
    fontFamily: 'var(--font-inter)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  sansSerifHighlight2SemiBold: {
    fontFamily: 'var(--font-inter)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  sansSerifHighlight1: {
    fontFamily: 'var(--font-inter)',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  sansSerifHighlight1Light: {
    fontFamily: 'var(--font-inter)',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  sansSerifHeadline: {
    fontFamily: 'var(--font-inter)',
    fontSize: '22px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  sansSerifSubHeading: {
    fontFamily: 'var(--font-inter)',
    fontSize: '16px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  sansSerifBody1: {
    fontFamily: 'var(--font-inter)',
    fontSize: '14px',
    lineHeight: '1.8514286em',
    fontWeight: 'normal'
  },
  sansSerifBody2: {
    fontFamily: 'var(--font-inter)',
    fontSize: '12px',
    lineHeight: '1.83333333em',
    fontWeight: 'normal'
  },
  sansSerifCaption: {
    fontFamily: 'var(--font-inter)',
    fontSize: '10px',
    lineHeight: '1.8em',
    fontWeight: 'normal'
  },
  serifHighlight3Large: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '120px',
    lineHeight: '1.666667em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3Medium: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '88px',
    lineHeight: '1.13636364em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3Small: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3SmallBold: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight3SmallLight: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '64px',
    lineHeight: '.875em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight2: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight2Light: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal',
    letterSpacing: '-1.5'
  },
  serifHighlight1: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  serifHighlight1Light: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '30px',
    lineHeight: '1.2em',
    fontWeight: 'normal'
  },
  serifHeadline: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '22px',
    lineHeight: '1.63636364em',
    fontWeight: 'normal'
  },
  serifHeadline2: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal'
  },
  serifHeadline2Bold: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '44px',
    lineHeight: '1.25em',
    fontWeight: 'normal'
  },
  serifSubHeading: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '16px',
    lineHeight: '1.625em',
    fontWeight: 'normal'
  },
  serifSubHeading2: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '22px',
    lineHeight: '1.63636364em',
    fontWeight: 'normal'
  },
  serifBody1: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '14px',
    lineHeight: '1.8514286em',
    fontWeight: 'normal'
  },
  serifBody2: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '12px',
    lineHeight: '1.83333333em',
    fontWeight: 'normal'
  },
  serifButton: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '12px',
    lineHeight: '1.83333333em',
    fontWeight: 'normal',
    letterSpacing: 1,
    textTransform: 'uppercase'
  },
  serifCaption: {
    fontFamily: 'var(--font-lexend)',
    fontSize: '10px',
    lineHeight: '1.8em',
    fontWeight: 'normal'
  },
  size10: {
    fontSize: '10px'
  },
  size12: {
    fontSize: '12px'
  },
  size14: {
    fontSize: '14px'
  },
  size15: {
    fontSize: '15px'
  },
  size16: {
    fontSize: '16px'
  },
  size18: {
    fontSize: '18px'
  },
  size22: {
    fontSize: '22px'
  },
  size30: {
    fontSize: '30px'
  },
  size38: {
    fontSize: '38px'
  },
  size44: {
    fontSize: '44px'
  },
  size56: {
    fontSize: '56px'
  },
  size64: {
    fontSize: '64px'
  },
  size88: {
    fontSize: '88px'
  },
  size120: {
    fontSize: '120px'
  }
};

export default typography;

